import React from 'react';
import styled from '@emotion/styled';
import CheckCircleIcon from 'assets/svg/check-circle-24.svg';
import CrossCircleIcon from 'assets/svg/circle-close.svg';
import { Text } from 'ds/components/typography';

const SuccessPopoverMessageRoot = styled.div<{ isPaidAndRunning?: boolean }>(({ theme, isPaidAndRunning }) => ({
  zIndex: 101,
  backgroundColor: isPaidAndRunning ? theme.colors.brand.darker : theme.colors.brand.main,
  borderRadius: '4px',
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  color: theme.colors.neutrals.white,
  '> svg path': {
    stroke: theme.colors.neutrals.white,
  },
}));

interface SuccessPopoverMessageProps {
  style: React.CSSProperties; // popper style
  message: string;
  withoutIcon?: boolean;
  isPaidAndRunning?: boolean;
  onClose?: () => void;
}

export const SuccessPopoverMessage = React.forwardRef<any, SuccessPopoverMessageProps>((props, ref) => {
  const { style, message, withoutIcon, isPaidAndRunning, onClose } = props;

  return (
    <SuccessPopoverMessageRoot ref={ref} style={style} isPaidAndRunning={isPaidAndRunning}>
      {withoutIcon ? null : (
        isPaidAndRunning ? <CrossCircleIcon width={24} height={24} onClick={onClose} /> : <CheckCircleIcon />
      )}
      <Text>{message}</Text>
    </SuccessPopoverMessageRoot>
  );
});
